// extracted by mini-css-extract-plugin
export default {"account":"AccountDropdown_account__mfqGo","account-light":"AccountDropdown_account-light__9W8Ri","account-dark":"AccountDropdown_account-dark__HSNIZ"};